module.exports = __webpack_public_path__ + "img/gmdl_icon6.c8c18661.png";